import React, { useEffect, useState } from 'react';
import useEnterKey from 'hooks/useKeydown';
import ls from 'local-storage';
import { useDispatch } from 'redux-react-hook';
import { updateUser } from 'store/DEPRECATEDusers/asyncAction';
import styled from 'styled-components';
import { isBlank } from 'utils/storeUtils';

import TrackingAPI from '../../../api/TrackingAPI';

export default function CharacterNameTool(props) {
  const { currentUser, onAuthClick = () => { } } = props;
  const dispatch = useDispatch();

  const [name, setName] = useState(props.name || 'Rick');
  const [gender, setGender] = useState('Not specified');
  const [characterDescription, setCharacterDescription] = useState('');

  const isMale = gender == 'male';
  const isFemale = gender == 'female';
  const isNotSpecifiedGender = gender == 'Not specified';

  useEffect(() => {
    const lastViewTimestamp = ls('character_name_opened');
    if (!lastViewTimestamp || +lastViewTimestamp < +new Date() - 24 * 60 * 60 * 1000) {
      ls('character_name_opened', +new Date());
      TrackingAPI.trackEvent('character_name_opened');
    }
  }, []);

  const handleSave = async () => {

    const lastViewTimestamp = ls('character_name_saved');
    if (!lastViewTimestamp || +lastViewTimestamp < +new Date() - 24 * 60 * 60 * 1000) {
      ls('character_name_saved', +new Date());
      TrackingAPI.trackEvent('character_name_saved');
    }

    if (currentUser) {
      await dispatch(
        updateUser({
          characterName: name,
          characterGender: gender,
          characterDescription: characterDescription,
          id: currentUser.id
        })
      );
    }
    ls('characterName', name);
    ls.set('ero_gender', gender);
    ls.set('ero_user_description', characterDescription);
    window.location.reload(); // TODO: убрать релоад - бесячий UX, посмотреть для чего это
  };

  useEnterKey('Enter', handleSave);

  return (
    <Wrapper style={{ paddingBottom: currentUser ? '' : '48px' }}>
      <div className={'my-2'}>Please, specify what should we call you</div>

      <TextFieldWrapper>
        <TextField
          className="focus:ring-0"
          placeholder="Name"
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </TextFieldWrapper>

      <div className="flex flex-col gap-2">
        <span>Gender</span>
        <div
          className="flex w-fit flex-row items-center space-x-4"
          onClick={() => {
            setGender('male');
          }}
          style={{ cursor: isMale ? 'default' : 'pointer' }}
        >
          <GenderRadio
            type="checkbox"
            checked={isMale}
            onChange={() => { }}
            className="border-none focus:ring-0 focus:ring-transparent focus:ring-offset-0"
          />
          <GenderCheckboxLabel selected={isMale}>Male</GenderCheckboxLabel>
        </div>

        <div
          className="flex w-fit flex-row items-center space-x-4"
          onClick={() => {
            setGender('female');
          }}
          style={{ cursor: isFemale ? 'default' : 'pointer' }}
        >
          <GenderRadio
            type="checkbox"
            checked={isFemale}
            onChange={() => { }}
            className="border-none focus:ring-0 focus:ring-transparent focus:ring-offset-0"
          />
          <GenderCheckboxLabel selected={isFemale}>Female</GenderCheckboxLabel>
        </div>

        <div
          className="flex w-fit flex-row items-center space-x-4"
          onClick={() => {
            setGender('Not specified');
          }}
          style={{ cursor: isNotSpecifiedGender ? 'default' : 'pointer' }}
        >
          <GenderRadio
            type="checkbox"
            checked={isNotSpecifiedGender}
            onChange={() => { }}
            className="border-none focus:ring-0 focus:ring-transparent focus:ring-offset-0"
          />
          <GenderCheckboxLabel selected={!gender}>Not specified</GenderCheckboxLabel>
        </div>

        <span className="mt-2">User description</span>
        <TextArea
          value={characterDescription}
          onChange={evt => {
            setCharacterDescription(evt.target.value);
          }}
          placeholder="Any details about you for our characters to use in the story"
        />
      </div>

      <div className={'my-4'}>
        <Button disabled={isBlank(name)} onClick={() => handleSave()}>Save</Button>
      </div>

      {!currentUser && (
        <div
          className={
            'color-white absolute left-0 bottom-0 w-full border-t border-t-[rgb(104,104,104)] py-4 text-center text-sm'
          }
        >
          <span>{`Already have an account? `}</span>{' '}
          <span
            className={'cursor-pointer text-[rgb(255,126,85)]'}
            onClick={() => {
              onAuthClick();
            }}
          >
            Sign in
          </span>
        </div>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const TextField = styled.input`
  background-color: rgba(19, 19, 19, 1) !important;
  border: 1px solid transparent;
  border-radius: 8px;
  color: white;
  width: 100%;
  font-size: 16px;
  outline: none;

  :focus {
    border-color: rgba(255, 126, 85, 1);
  }

  ::placeholder {
    color: rgba(105, 105, 105, 1);
  }
`;

const TextFieldWrapper = styled.div`
  padding-bottom: 0.5rem;
`;

const Button = styled.button`
  background: rgba(255, 126, 85, 1);
  box-shadow: 0px 12px 40px 0px rgba(255, 126, 85, 0.12);
  width: 100%;
  border-radius: 100px;
  color: white;
  font-weight: bold;
  padding-left: 15px;
  padding-right: 15px;
  height: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;

  :disabled {
    background: #818181;
    cursor: not-allowed;
  }

  :hover {
    opacity: 0.8;
  }
`;

const Radio = styled.input`
  width: 20px;
  height: 20px;
  background: linear-gradient(
    90deg,
    rgba(158, 94, 238, 0.15) 0%,
    rgba(183, 89, 234, 0.15) 32%,
    rgba(198, 93, 233, 0.15) 66%,
    rgba(184, 133, 244, 0.15) 100%
  );
  border-radius: 20px;
  cursor: pointer;

  :checked {
    background-color: rgba(255, 126, 85, 1) !important;
  }
`;

const GenderRadio = styled(Radio)`
  background: rgba(104, 104, 104, 1);
`;

const CheckboxLabel = styled.span`
  background: ${props =>
    props?.selected
      ? ''
      : 'linear-gradient(90deg, #9E5EEE 0%, #B759EA 32%, #C65DE9 66%, #B885F4 100%)'};
  padding: 2px 6px;
  border-radius: 20px;
  color: white;
  font-size: 16px;
  line-height: 18px;
  font-family: 'Nunito Sans';
  ::first-letter {
    text-transform: uppercase;
  }
`;

const GenderCheckboxLabel = styled(CheckboxLabel)`
  background: transparent;
`;

const TextArea = styled.textarea`
  background-color: rgba(19, 19, 19, 1) !important;
  border: 1px solid transparent;
  border-radius: 8px;
  color: white;
  min-height: 80px;
  font-size: 16px;
  line-height: 18px;
  outline: none;
  font-family: Nunito Sans;
  padding: 10px;
  :focus {
    border-color: #ff7e55;
    box-shadow: none !important;
  }
`;
